function page_view() {
  window.cps?.("event", {
    event_name: "cancel_subscribe_page",
    event_category: "cancel_subscribe_page",
    event_action: "page_view",
  });
  window.cps?.("event", {
    event_name: "continue_subscribe",
    event_category: "cancel_subscribe_page",
    event_action: "view",
  });
  window.cps?.("event", {
    event_name: "submit",
    event_category: "cancel_subscribe_page",
    event_action: "view",
  });
}
function button_click(unsubscribe = false) {
  window.cps?.("event", {
    event_name: unsubscribe ? "submit" : "continue_subscribe",
    event_category: "cancel_subscribe_page",
    event_action: "click",
  });
}

export { page_view, button_click };
